import { Header } from "@/components/layout/Header";
import { Profile } from "@/components/user/profile/ui/Profile";

export const ProfilePage = () => {
	return (
		<div className="overflow-y-scroll h-full">
			<Header />

			<div className="flex px-3 py-5 justify-center">
				<Profile />
			</div>
		</div>
	);
};
